import type { InvoiceTableAction } from '@/components/InvoiceTable';

/**
 * Decide se a ação aparece no menu da linha, dado o estado da fatura.
 *
 * Origem: sem issue — commit 29c36b104, 2026-06-09 19:05 +0200.
 *
 * Usado por: `components/InvoiceTable.tsx` (coluna de ações). Arquivo próprio
 * porque o `react-refresh` do admin reprova função exportada junto de componente.
 *
 * Dicas: "Cancelar" segue a regra do `cancelInvoice` (só PENDING); manter as
 * duas iguais, senão o operador vê um botão que o servidor recusa (#935).
 */
export function isActionVisible(
  action: InvoiceTableAction,
  ctx: {
    canPay: boolean;
    isPending: boolean;
    hasPdf: boolean;
    hasNfe: boolean;
    hasNfeLabel: boolean;
  },
): boolean {
  switch (action) {
    case 'view':
    case 'resend_email':
      return true;
    case 'download_pdf':
      return ctx.hasPdf;
    case 'download_nfe':
      return ctx.hasNfe && ctx.hasNfeLabel;
    case 'pay_now':
    case 'mark_paid':
      return ctx.canPay;
    case 'cancel':
      // Bug corrigido em 2026-10-13 10:28 +0200 (#935, item 7): era "não PAID
      // nem CANCELLED", e OVERDUE/VOID/REFUNDED mostravam uma ação que o
      // `cancelInvoice` recusa (`failed-precondition`). Só PENDING cancela.
      return ctx.isPending;
  }
}
